//download.js
import axios from "axios"  //需要单独引入，因为当前.js文件不会被vue管理
axios.defaults.headers['Cache-Control'] = 'no-cache'
/*
    url: "http://124.127.246.224:9000/images/2022/10/17/c24f8fd7d53.pdf"
    options: {title:"",fileType:"application/pdf"}
    ele: a标签
*/
let getFile = (url, options, ele) => {
    axios.get(url, { responseType: 'blob' }).then(res => download(res, options, ele))
}

let download = (res, options, ele) => {
    let blob = new Blob([res.data], { type: options.fileType ? options.fileType : "application/octet-binary" });
    let href = window.URL.createObjectURL(blob);
    downloadBlob(href, options, ele);
}

let flag = 1;
let downloadBlob = (blobUrl, options, ele) => {
    ele.href = blobUrl;
    ele.download = options.title;
    flag++;
    if ((flag % 2) == 0) {
        ele.click();
        window.URL.revokeObjectURL(blobUrl);
    }
}

export {
    getFile,
    download,
    downloadBlob
}



// WEBPACK FOOTER //
// ./src/assets/js/download.js